import { Api } from "../config/request";

export default {
  bulkUploadCarrierChange(payload) {
    return Api.post("/bulk-upsert-carrier", payload);
  },
};
